import React, { Fragment, useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, Popover } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { userSignIn } from "../appRedux/actions/Auth";
import InfoView from "components/InfoView";
import logo from '../assets/images/qhse-logo.png';
import logoPP from '../assets/images/logo_pp.png';
import background from '../assets/images/background.jpg';
import Auxiliary from "../util/Auxiliary";
import Modal from "antd/lib/modal/Modal";
import { Link } from 'react-router-dom';
import { Button as AntButton } from 'antd';


const SignIn = (props) => {
  const dispatch = useDispatch();
  const [withPassword, setWithPassword] = useState(false);
  const token = useSelector(({ auth }) => auth.token);
  const urlParams = new URLSearchParams(window.location.search);
  const authorizationCode = urlParams.get('code');
  var role = localStorage.getItem('setRole') === null ? "User" : localStorage.getItem('setRole');

  const onMicrosoftLogin = () => {
    const tennantId = process.env.REACT_APP_TENANT_ID;
    const appId = process.env.REACT_APP_APP_ID;
    const redirectUrl = encodeURIComponent(process.env.REACT_APP_REDIRECT_URL);
    const responseType = 'code';
    const scope = 'User.Read offline_access';

    const loginUrl = `https://login.microsoftonline.com/${tennantId}/oauth2/v2.0/authorize` +
      `?client_id=${appId}&redirect_uri=${redirectUrl}&response_type=${responseType}&scope=${scope}`;

    window.location.href = loginUrl;
  };

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const onFinish = values => {
    dispatch(userSignIn({ ...values, withPassword}));
  };

  useEffect(() => {
    if (token !== null) {
      localStorage.setItem("typeLogin", withPassword ? "With Password" : "Without password" );
      props.history.push('/');
    }
  }, [token, props.history]);

  useEffect(() => {
    if (authorizationCode !== null) {
      dispatch(userSignIn({ role, authorizationCode, withPassword }));
    }
    role = localStorage.getItem('setRole') === null ? "User" : localStorage.getItem('setRole');
  }, [authorizationCode, dispatch]);


  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
              <img src={background} alt='Neature' />
            </div>
            <div className="gx-app-logo-wid">
              <h1>Login {withPassword ? "Vendor" : "User"}</h1>
              <p>Selamat datang di QHSE Passport PTPP</p>
            </div>
            <div className="gx-app-logo">
              <img alt="example" src={logo} />
            </div>
          </div>
          <div className="gx-app-login-content">
            <Form
              initialValues={{ remember: true }}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0">

              {withPassword ? (
                <>
                  <Form.Item
                    name="email"
                    initialValue=""
                    rules={[{ required: true, message: 'Masukkan username Anda' }]}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    initialValue=""
                    rules={[{ required: true, message: 'Masukkan password Anda' }]}
                  >
                    <Input type="password" placeholder="Password" />
                  </Form.Item>
                </>
              ) : (
                <Form.Item style={{ textAlign: 'center' }}>
                  <AntButton
                    type="primary"
                    block
                    className="gx-mb-0"
                    onClick={onMicrosoftLogin}
                  >
                    <img src={logoPP} alt="Microsoft Icon" style={{ marginRight: 8, width:25 }} />
                    Login dengan SSO PTPP
                  </AntButton>
                </Form.Item>
              )}

              <Form.Item>
                {withPassword ? (
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    Login
                  </Button>
                ) : (
                  <></>
                )}
                <Popover
                  overlayClassName="gx-popover-horizontal"
                  trigger="hover"
                  content={(
                    <div>
                      Silahkan klik link <a href="https://ptpp.link/DaftarQHSEPASS">https://ptpp.link/DaftarQHSEPASS</a> atau admin QHSE Proyek
                    </div>
                  )}
                >
                  <span className="text-blue">Belum Terdaftar?</span>
                </Popover>
              </Form.Item>

              <Form.Item name="remember" valuePropName="checked">
                <Checkbox>Biarkan tetap masuk</Checkbox>
              </Form.Item>

              <div className="gx-mt-1">
                {withPassword ? (
                  <Popover overlayClassName="gx-popover-horizontal" trigger="hover" placement="bottom" content="Klik untuk masuk menggunakan akun email PTPP">
                    <button
                      type="button"
                      className="ant-btn ant-btn-link gx-mb-0"
                      onClick={() => setWithPassword(false)}
                      style={{ padding: 0 }}
                    >
                      Login dengan SSO PTPP
                    </button>
                  </Popover>
                ) : (
                  <Popover overlayClassName="gx-popover-horizontal" trigger="hover" placement="bottom" content="Klik untuk masuk menggunakan username dan password">
                    <button
                      type="button"
                      className="ant-btn ant-btn-link gx-mb-0"
                      onClick={() => setWithPassword(true)}
                      style={{ padding: 0 }}
                    >
                      Login vendor
                    </button>
                  </Popover>
                )}
              </div>

              {/* <div className="gx-mt-1">
                {isAdmin ? (
                  <Popover overlayClassName="gx-popover-horizontal" trigger="hover" placement="bottom" content="Klik untuk masuk ke halaman Login User">
                    <button
                      type="button"
                      className="ant-btn ant-btn-link gx-mb-0"
                      onClick={() => setIsAdmin(false)}
                      style={{ padding: 0 }}
                    >
                      Kembali
                    </button>
                  </Popover>
                ) : (
                  <Popover overlayClassName="gx-popover-horizontal" trigger="hover" placement="bottom" content="Klik untuk masuk ke halaman Login Administrator QHSE Passport">
                    <button
                      type="button"
                      className="ant-btn ant-btn-link gx-mb-0"
                      onClick={() => setIsAdmin(true)}
                      style={{ padding: 0 }}
                    >
                      Login sebagai Admin
                    </button>
                  </Popover>
                )}
              </div> */}

              <div className="gx-mt-3">
                <Link to={`/scan`}>
                  <Button type="default" block size="medium">Scan ID</Button>
                </Link>
              </div>

            </Form>
          </div>
          <InfoView />
        </div>
      </div>
      <div className="gx-mt-3 gx-text-center">
        <Disclaimer />
      </div>
    </div>
  );
};

export default SignIn;

const Disclaimer = () => {
  const [open, setOpen] = useState(false);
  return (
    <Auxiliary>
      <button
        type="button"
        className="ant-btn ant-btn-link gx-mb-0"
        onClick={() => setOpen(true)}
        style={{ padding: 0 }}
      >
        Disclaimer
      </button>
      <Modal title="Disclaimer" visible={open} onCancel={() => setOpen(false)} onOk={() => setOpen(false)}>
        <div>
          <h4 style={{ textAlign: "center" }}>DISCLAIMER</h4>
          PENGANTAR
          <hr style={{ borderTop: "1px dashed" }} />
          Informasi yang diberikan oleh QHSE bisnis dan entitas di <a href="https://passport.ptpp.co.id/">passport.ptpp.co.id</a> dan aplikasi seluler kami hanya untuk tujuan kepentingan perusahaan. Semua informasi di situs dan aplikasi seluler kami disediakan dengan itikad baik, namun kami tidak membuat presentasi atau jaminan dalam bentuk apa pun, tersurat maupun tersirat, mengenai keakuratan dan kecukupan, validitas, keandalan, ketersediaan atau kelengkapan informasi apa pun di situs atau aplikasi seluler kami.

          Dalam keadaan apa pun kami tidak bertanggung jawab kepada Anda atas kehilangan atau kerusakan dalam bentuk apa pun yang terjadi sebagai akibat dari penggunaan situs atau aplikasi seluler kami atau ketergantungan pada informasi apa pun yang disediakan di situs atau aplikasi seluler kami. Penggunaan situs dan aplikasi seluler kami oleh Anda dan ketergantungan Anda pada informasi apa pun pada platform ini sepenuhnya merupakan risiko Anda sendiri

          PENOLAKAN LINK EKSTERNAL UNTUK APLIKASI SELULER
          <hr style={{ borderTop: "1px dashed" }} />
          Situs dan aplikasi seluler kami dapat berisi ( Anda dapat menerima melalui situs atau aplikasi seluler kami) tautan ke situs web lain atau konten milik kami yang berasal dari pihak ketiga atau tautan ke situs web dan fitur dalam spanduk atau iklan lainnya. tautan eksternal tersebut tidak diselidiki, dipantau, atau diperiksa keakuratannya, kecukupannya, validitasnya, keandalannya, ketersediaannya, atau kelengkapannya oleh kami.

          <hr style={{ borderTop: "1px dashed currentcolor" }} />
          <p style={{ textAlign: "center" }}>BIRO QHSE & SM  &copy; 2021 | <a href="https://passport.ptpp.co.id/">QHSE PASS VER 0</a></p>
        </div>
      </Modal>
    </Auxiliary>
  );
}
